<template>
  <div class="exa-page">
    <!-- 顶部子导航栏 -->
    <div class="sub-nav">
      <a href="#/" class="sub-nav-back">← 返回首页</a>
      <span class="sub-nav-title">云展览 · 全部展商</span>
    </div>

    <!-- 头部文案 -->
    <section class="exa-head">
      <div class="exa-head-tag">
        <span class="exa-head-line"></span>
        CLOUD EXHIBITION
        <span class="exa-head-line"></span>
      </div>
      <h1 class="exa-head-title">云展览</h1>
      <p class="exa-head-desc">
        足不出户云逛展，线上沉浸式观展体验，随时回看精彩内容
      </p>
    </section>

    <!-- 展商列表 -->
    <section class="exa-list-wrap">
      <div class="exa-list">
        <div
          v-for="(item, idx) in exhibitors"
          :key="item.enterprise_id"
          class="exa-card"
          :class="{ alt: idx % 2 === 1 }"
          @click="handleClick(item)"
        >
          <div class="exa-logo">
            <img
              :src="item.logo_path"
              :alt="item.name"
              class="exa-logo-img"
              @error="onLogoError($event, item)"
            />
          </div>
          <div class="exa-card-body">
            <h3 class="exa-brand">
              <span class="exa-no">{{ cnNums[idx] }}</span
              >{{ item.name }}
            </h3>
            <div class="exa-dash"></div>
            <div class="exa-company">{{ item.company_name }}</div>
            <div class="exa-contact-row">
              <span class="exa-contact">
                <svg class="exa-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
                {{ item.contact }}
              </span>
              <span class="exa-contact">
                <svg class="exa-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
                {{ item.phone_format }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import exhibitsData from "@/data/exhibits.json";

export default {
  name: "ExhibitAll",
  data() {
    return {
      exhibitors: exhibitsData,
      cnNums: [
        "(一)",
        "(二)",
        "(三)",
        "(四)",
        "(五)",
        "(六)",
        "(七)",
        "(八)",
        "(九)",
        "(十)",
        "(十一)",
        "(十二)",
        "(十三)",
        "(十四)",
        "(十五)",
        "(十六)",
        "(十七)",
        "(十八)",
        "(十九)",
        "(二十)",
        "(二十一)",
        "(二十二)",
        "(二十三)",
        "(二十四)",
        "(二十五)",
        "(二十六)",
        "(二十七)",
        "(二十八)",
        "(二十九)",
      ],
    };
  },
  methods: {
    handleClick(item) {
      const { enterprise_id } = item;
      window.open(
        `https://jinshi.online/enterprise/${enterprise_id}`,
        "_blank",
        "noopener,noreferrer"
      );
    },
    // 图片加载失败时 fallback 到品牌首字占位
    onLogoError(e, item) {
      const img = e.target;
      if (img.dataset.fallback === "1") return;
      img.dataset.fallback = "1";
      // 用 canvas 或 base64 svg 做 fallback
      const brand = (item.name || "养").slice(0, 2);
      const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 140"><defs><linearGradient id="g" x1="0" y1="0" x2="1" y2="1"><stop offset="0%" stop-color="#FFE0B8"/><stop offset="100%" stop-color="#FFD38A"/></linearGradient></defs><rect width="200" height="140" rx="14" fill="url(#g)" stroke="#F4BD7B" stroke-width="2"/><text x="50%" y="54%" text-anchor="middle" dominant-baseline="middle" font-family="serif" font-weight="900" font-size="30" fill="#C25A2D" letter-spacing="2">${brand}</text></svg>`;
      img.src =
        "data:image/svg+xml;base64," + btoa(unescape(encodeURIComponent(svg)));
    },
  },
};
</script>

<style scoped>
.exa-page {
  min-height: 100vh;
  background: #fff4e6;
  color: var(--color-text);
  padding-bottom: 120px;
}

/* ===== 顶部子导航 ===== */
.sub-nav {
  position: sticky;
  top: 0;
  z-index: 100;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 32px;
  background: #fff;
  border-bottom: 1px solid #f0e3d1;
}
.sub-nav-back {
  font-size: 15px;
  font-weight: 700;
  color: #e27a1d;
  text-decoration: none;
  letter-spacing: 0.5px;
}
.sub-nav-back:hover {
  opacity: 0.75;
}
.sub-nav-title {
  font-family: var(--font-serif);
  font-size: 18px;
  font-weight: 900;
  color: var(--color-text);
}

/* ===== 头部 ===== */
.exa-head {
  text-align: center;
  padding: 100px 32px 64px;
}
.exa-head-tag {
  display: inline-flex;
  align-items: center;
  gap: 18px;
  color: #d4680a;
  font-family: var(--font-serif);
  font-size: 15px;
  font-weight: 700;
  letter-spacing: 5px;
  margin-bottom: 20px;
}
.exa-head-line {
  display: inline-block;
  width: 36px;
  height: 1px;
  background: #e2a770;
}
.exa-head-title {
  font-family: var(--font-serif);
  font-size: clamp(44px, 7vw, 72px);
  font-weight: 900;
  color: #2b2420;
  margin: 0 0 18px;
  line-height: 1.1;
}
.exa-head-desc {
  font-size: 17px;
  line-height: 1.9;
  color: #6b5d54;
  margin: 0;
}

/* ===== 列表 ===== */
.exa-list-wrap {
  padding: 0 32px;
}
.exa-list {
  max-width: 1100px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 28px;
}
.exa-card {
  display: flex;
  gap: 32px;
  background: #fff;
  border-radius: 20px;
  padding: 36px 40px;
  box-shadow: 0 4px 20px rgba(237, 123, 26, 0.07);
  align-items: flex-start;
  cursor: pointer;
}
.exa-card.alt {
  background: #fff8ee;
  box-shadow: 0 4px 20px rgba(237, 123, 26, 0.04);
}

/* LOGO */
.exa-logo {
  flex-shrink: 0;
}
.exa-logo-img {
  width: 200px;
  height: 140px;
  border-radius: 14px;
  object-fit: cover;
  background: #fff;
  border: 2px solid #f4bd7b;
  display: block;
}

/* 卡片主体 */
.exa-card-body {
  flex: 1;
  min-width: 0;
  padding-top: 4px;
}
.exa-brand {
  margin: 0 0 8px;
  font-family: var(--font-serif);
  font-size: 24px;
  font-weight: 900;
  color: #c85c1b;
  display: flex;
  align-items: center;
  gap: 14px;
}
.exa-no {
  display: inline-block;
  padding: 4px 14px;
  background: linear-gradient(135deg, #f2a24a, #e77b19);
  color: #fff;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.5px;
  box-shadow: 0 3px 8px rgba(231, 123, 25, 0.25);
}
.exa-dash {
  height: 1px;
  background-image: linear-gradient(to right, #e8c8a3 50%, transparent 50%);
  background-size: 8px 1px;
  background-repeat: repeat-x;
  margin: 0 0 14px;
}
.exa-company {
  font-size: 15px;
  color: #6b5d54;
  margin-bottom: 6px;
}
.exa-contact-row {
  display: flex;
  gap: 24px;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 10px;
}
.exa-contact {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  color: var(--color-primary-deep);
  font-weight: 600;
}
.exa-icon {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}
@media (max-width: 820px) {
  .sub-nav {
    padding: 14px 20px;
  }
  .exa-head {
    padding: 64px 16px 48px;
  }
  .exa-list-wrap {
    padding: 0 16px;
  }
  .exa-card {
    flex-direction: column;
    gap: 20px;
    padding: 28px 20px;
    border-radius: 16px;
  }
  .exa-logo-img {
    width: 100%;
    max-width: 300px;
    height: auto;
    min-height: 120px;
  }
  .exa-brand {
    font-size: 20px;
    flex-wrap: wrap;
    gap: 10px;
  }
}
</style>
